module.exports = __webpack_public_path__ + "static/media/viewingContactNavigation.7fb5eed9.png";